const ChevronDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 19.061 10.591">
            <path
                id="Path_3490"
                data-name="Path 3490"
                d="M5271.342,2230l9,9,9-9"
                transform="translate(-5270.812 -2229.47)"
                fill="none"
                stroke="var(--icon-color)"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default ChevronDown;
